const urls = class {
	
	static drawFlag() {
		const baseUrl = '/draw-flag';
	
		const get = `${baseUrl}/get/`
		return {
			get
		}
	}
	
    // 图库
	static gallery() {
		const baseUrl = '/img';
	
		const list = `${baseUrl}/list`
		const moduleImageList = `${baseUrl}/module-image/list/`
		return {
			list,
			moduleImageList
		}
	}


	//开奖
	static officialGallery() {
		const baseUrl = '/official-gallery';
		const list = `${baseUrl}/list`
		return {
			list
		}
	}

	static adly() {
		const baseUrl = '/adly';
		const text = `${baseUrl}/text`;
		const history = `${baseUrl}/history/get`
		const historyList = `${baseUrl}/history/list`
		const listAdly = `${baseUrl}/list`
		return {
			history,
			text,
			historyList,
			listAdly
		}
	}
	
	static xgc() {
		const baseUrl = '/xgc';
	
		const history = `${baseUrl}/history/get`
		const historyList = `${baseUrl}/history/list`
		const listAdly = `${baseUrl}/list`
		return {
			history,
			historyList,
			listAdly
		}
	}
	static xac() {
		const baseUrl = '/xac';
	
		const history = `${baseUrl}/history/get`
		const historyList = `${baseUrl}/history/list`
		const listAdly = `${baseUrl}/list`
		return {
			history,
			historyList,
			listAdly
		}
	}

	//预测分组
	static predictionGroup() {
		const baseUrl = '/perdiction-group';
		const list = `${baseUrl}/list`
		const all = `${baseUrl}/all/list`
		const moduleSortList = `${baseUrl}/module-sort/list`

		return {
			all,
			list,
			moduleSortList
		}
	}

	// 预测
	static prediction() {
		const baseUrl = '/prediction';

		const list = `${baseUrl}/list`

		return {
			list
		}
	}
}

export default urls
